import React from 'react'
import { useNavigate } from 'react-router-dom'

const NewLoginModal = ({ show, onClose, message }) => {
  const navigate = useNavigate();

  if (!show) return null;
  
  const handleCompleteProfile = () => {
    navigate('/login');
  };
  
  return (
    <div 
      className="modal" 
      style={{ 
        display: show ? 'block' : 'none',
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0,0,0,0.5)',
        zIndex: 1050
      }}
      onClick={onClose}
    >
      <div 
        className="modal-dialog modal-dialog-centered"
        onClick={e => e.stopPropagation()}
      >
        <div className="modal-content"style={{ minHeight: '50vh' }}>
          <div className="modal-header border-bottom-0">
            <button 
              type="button" 
              className="btn-close" 
              onClick={onClose}
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body text-center pb-4">
            <div className="position-relative d-inline-block mb-4">
             
            <i class="fa-solid fa-user-slash fa-2xl text-primary"></i>
            
              
            </div>
            
            <h5 className="modal-title mb-3">Not Logged in</h5>
            <p className="text-muted mb-4">{message}</p>
            <p className="text-muted mb-4">{" Are you a New User ? Please "} <a href="/register" rel="noreferrer"  style={{ textDecoration: "underline", color: "blue" }}>register</a></p>
            
            <div className="d-flex justify-content-center gap-3">
              <button 
                type="button" 
                className="btn btn-primary px-4"
                onClick={handleCompleteProfile}
              >
                Login
              </button>
              <button 
                type="button" 
                className="btn btn-outline-secondary px-4" 
                onClick={onClose}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NewLoginModal 